import axios from "axios";
import { config, getDomain, tempAlErr, tempAlWait } from "../helpers";
import { alertIndex } from "../helpers/alertIndex";
import { GAL_DEL, GAL_DETAILS, GAL_LIKE, GAL_LIST, GAL_SAVE } from "./action-types";

// Liste des images de la gallerie
export function getGallerie() {
    return function (dispatch) {
        let user = null;
        let cred = null;
        if (localStorage.getItem('userId')) {
            user = localStorage.getItem('userId');
        }
        if (localStorage.getItem('userCred')) {
            cred = localStorage.getItem('userCred');
        }
        let alert = tempAlWait();
        let datas = [];

        axios.post(`${getDomain()}api/gallerie/list`, {
            userId: user,
            credentials: cred
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                    localStorage.setItem('galerie', JSON.stringify(res.datas));
                }

                dispatch({
                    type: GAL_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("gali002");
                dispatch({
                    type: GAL_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Détails d'une gallerie
export function getDetailGallerie({gallId}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = null;

        axios.post(`${getDomain()}api/gallerie/details/${gallId}`, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: GAL_DETAILS,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("gade002");
                dispatch({
                    type: GAL_DETAILS,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Ajouter une gallerie
export function addGallerie({
    img,
    desc,
    gallId = null
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/gallerie/save`;
        if (gallId != null) {
            url += `/${gallId}`;
        }

        axios.post(url, {
            img: img,
            desc: desc,
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                dispatch({
                    type: GAL_SAVE,
                    payload: {
                        alert: alert,
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("gad005");
                dispatch({
                    type: GAL_SAVE,
                    payload: {
                        alert: alert
                    }
                })
            })
    }
}

// Supprimer une gallerie
export function delGallerie({gallId}) {
    return function (dispatch) {
        let alert = tempAlWait();

        axios.post(`${getDomain()}api/gallerie/delete/${gallId}`, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                dispatch({
                    type: GAL_DEL,
                    payload: {
                        alert: alert
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("gasu004");
                dispatch({
                    type: GAL_DEL,
                    payload: {
                        alert: alert,
                    }
                })
            })
    }
}

// Mettre un like sur une gallerie
export function likeGallerie({gallId}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;

        axios.post(`${getDomain()}api/gallerie/like/${gallId}`, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: GAL_LIKE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("gali003");
                dispatch({
                    type: GAL_LIKE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}